<template>

    <div class="share-box" v-if="visible" @click="close">

        <img :src="imgUrl" alt="">

    </div>

</template>

<script>
    export default {
        name: "Share",
        data(){
            return {
                visible:this.value,
                imgUrl:'./images/share.png'
            }
        },

        props:{
            value:{
                defalut:false,
            }
        },

        watch:{
            value(boolean){
                this.visible = boolean
            }
        },

        methods:{
            close(){
                this.$emit('input',this.visible = false);
            }
        }

    }
</script>

<style lang="less">

    @import "../../styles/cssBlock";

    .share-box{
        .fixedByCover;
        background-color: @maskBgColor !important;
        z-index: 9999;
        >img{
            width: 100%;
            height: 100%;
        }
    }

</style>
